import { TouchableButton } from '@/shared/ui/TouchableButton'
import { AssetIcon } from '@/shared/ui/Asset'
import { cn } from '@lair-finance/util'
import { PopoverClose } from '@lair-finance/uikit'

export function CloseButton({ className }: { className?: string }) {
  return (
    <PopoverClose className={cn('disabled:pointer-events-none', className)}>
      <TouchableButton size={40} as={'div'}>
        <AssetIcon filename={'close.png'} size={24} />
      </TouchableButton>
      <span className="sr-only">Close</span>
    </PopoverClose>
  )
}
